import React from "react";
import { usePermissions } from "../hooks/usePermissions";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  children,
  requiredPermissions,
  fallback = <Navigate to="/unauthorized" replace />,
  showFallback = true,
}) => {
  const { canAccess, user } = usePermissions();

  // Attendre que l'utilisateur soit chargé avant de vérifier les permissions
  if (user === null || user === undefined) {
    // Afficher un loader pendant le chargement
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500"></div>
          <p className="text-gray-600 font-medium">
            Vérification des permissions...
          </p>
        </div>
      </div>
    );
  }

  if (!canAccess(requiredPermissions)) {
    return showFallback ? fallback : null;
  }

  return children;
};

export default ProtectedRoute;
